import {useEffect, useState} from 'react';
import {formatWelcomeGreeting} from '../utils/greeting';
import {
    BootstrapLogo,
    BootstrapProgressBar,
    BootstrapProgressTrack,
    BootstrapScreen,
    BootstrapSubtitle,
    BootstrapTitle,
} from './bootstrap.style';

const SUBTITLES = [
    'Загружаем ваш рабочий стол…',
    'Настраиваем доступ…',
    'Почти готово…',
];

type AppBootstrapScreenProps = {
    displayName?: string | null;
    subtitle?: string;
    rotateSubtitles?: boolean;
    overlay?: boolean;
    fading?: boolean;
    variant?: 'welcome' | 'silent';
    onFadeComplete?: () => void;
};

const AppBootstrapScreen = ({
    displayName,
    subtitle,
    rotateSubtitles = true,
    overlay = false,
    fading = false,
    variant = 'welcome',
    onFadeComplete,
}: AppBootstrapScreenProps) => {
    const [subtitleIndex, setSubtitleIndex] = useState(0);
    const isSilent = variant === 'silent';
    const greeting = formatWelcomeGreeting(displayName);
    const activeSubtitle = subtitle ?? (isSilent ? 'Загружаем…' : SUBTITLES[subtitleIndex]);

    useEffect(() => {
        if (subtitle || !rotateSubtitles || isSilent) return;

        const timer = window.setInterval(() => {
            setSubtitleIndex((current) => (current + 1) % SUBTITLES.length);
        }, 900);

        return () => window.clearInterval(timer);
    }, [rotateSubtitles, subtitle, isSilent]);

    return (
        <BootstrapScreen
            $overlay={overlay}
            $fading={fading}
            role="status"
            aria-live="polite"
            aria-busy={!fading}
            onTransitionEnd={(event) => {
                if (fading && event.propertyName === 'opacity') {
                    onFadeComplete?.();
                }
            }}
        >
            <BootstrapLogo />
            {!isSilent && <BootstrapTitle>{greeting}</BootstrapTitle>}
            <BootstrapSubtitle>{activeSubtitle}</BootstrapSubtitle>
            <BootstrapProgressTrack>
                <BootstrapProgressBar />
            </BootstrapProgressTrack>
        </BootstrapScreen>
    );
};

export default AppBootstrapScreen;
